// src/components/intake/bodies/RankBody.jsx
import React from "react";
import { OTHER_MAX, OptionCard, SetLabel, TextAnswer } from "../IntakeParts";
import { MAX_RANKED } from "../intakeRules";
import {
  RANKED_AS,
  RANKED_LIST_LABEL,
  RANKED_SLOT,
  RANK_INSTRUCTION,
  SOMETHING_ELSE,
} from "../intakeCopy";

// Q1 (kind `rank`, decision 28): tap-to-rank. Each option is a checkbox;
// ticking gives it the next free rank ("…, ranked 1") and un-ticking closes
// the gap, so the tick order is the rank (R390: no Move up / Move down; to
// reorder, un-tick and re-tick). The "Your top 3" list is a polite live
// region, so every change of order is announced. No drag.
export default function RankBody({ page, draft, onChange, idPrefix }) {
  const options = page.questions[0].options;
  const { ranked } = draft;
  const full = ranked.length >= MAX_RANKED;
  const set = (next) => onChange({ ...draft, ranked: next });
  const toggle = (option) =>
    ranked.includes(option)
      ? set(ranked.filter((o) => o !== option))
      : !full && set([...ranked, option]);
  const labelId = `${idPrefix}-rank-label`;

  return (
    <>
      <SetLabel id={labelId}>{RANK_INSTRUCTION}</SetLabel>
      <ul
        aria-label={RANKED_LIST_LABEL}
        aria-live="polite"
        className="tw-m-0 tw-mt-3 tw-flex tw-list-none tw-flex-wrap tw-gap-2 tw-p-0"
      >
        {Array.from({ length: MAX_RANKED }, (_, i) => (
          <li
            key={i}
            className="tw-inline-flex tw-min-h-8 tw-items-center tw-rounded-pill tw-border tw-border-solid tw-border-border tw-bg-surface tw-px-3 tw-text-xs tw-font-semibold"
          >
            {RANKED_SLOT(i + 1, ranked[i])}
          </li>
        ))}
      </ul>
      <ul
        role="group"
        aria-labelledby={`${idPrefix}-h1 ${labelId}`}
        className="tw-m-0 tw-my-6 tw-grid tw-list-none tw-grid-cols-1 tw-gap-3 tw-p-0 sm:tw-grid-cols-2 lg:tw-grid-cols-3"
      >
        {options.map((option) => {
          const rank = ranked.indexOf(option) + 1;
          return (
            <li key={option} className="tw-grid tw-content-start tw-gap-2">
              <OptionCard
                label={option}
                checked={rank > 0}
                disabled={rank === 0 && full}
                onChange={() => toggle(option)}
                srExtra={rank > 0 ? RANKED_AS(rank) : null}
                mark={rank > 0 ? rank : null}
              />
            </li>
          );
        })}
      </ul>
      <TextAnswer
        id={`${idPrefix}-other`}
        label={SOMETHING_ELSE}
        value={draft.other}
        max={OTHER_MAX}
        onChange={(other) => onChange({ ...draft, other })}
      />
    </>
  );
}
